import { render } from "./ApplicationsList.vue?vue&type=template&id=472fcd96"
import script from "./ApplicationsList.vue?vue&type=script&lang=js"
export * from "./ApplicationsList.vue?vue&type=script&lang=js"

import "./ApplicationsList.vue?vue&type=style&index=0&id=472fcd96&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__